import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import './Stack.css';

const Stack = () => {
  const { tr } = useLanguage();

  return (
    <section id="stack" className="stack">
      <p className="section-title">{tr.stack.title}</p>
      <div className="stack-grid">
        {tr.stack.categories.map(cat => (
          <div key={cat.name} className="stack-category">
            <h3 className="stack-cat-name">{cat.name}</h3>
            <div className="stack-chips">
              {cat.items.map(item => (
                <span key={item} className="stack-chip">{item}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stack;
